import React from "react";
import { classNames } from "../../utils/helpers";

export const SectionCard = ({
  title,
  right,
  children,
  isRetailerMobile = false,
  className = "",
}) => (
  <div
    className={classNames(
      "rounded-2xl p-4 flex flex-col min-h-[300px] transition-all duration-300",
      isRetailerMobile
        ? "bg-white/10 backdrop-blur-2xl border border-white/30 shadow-[0_20px_50px_rgba(31,38,135,0.25)]"
        : "bg-white/90 border border-slate-100/80 shadow-sm hover:shadow-md",
      className
    )}
  >
    <div className="flex items-center justify-between mb-3 gap-2">
      <h2
        className={classNames(
          "text-sm font-semibold flex items-center gap-2",
          isRetailerMobile ? "text-slate-900" : "text-slate-700"
        )}
      >
        <span
          className={classNames(
            "w-1.5 h-1.5 rounded-full",
            isRetailerMobile ? "bg-blue-400" : "bg-blue-500"
          )}
        />
        {title}
      </h2>
      {right}
    </div>

    <div className="flex-1">{children}</div>
  </div>
);
